import Sdk from 'casdoor-js-sdk';
import { API_BASE, CYBERKOALA_ID_SDK_CONFIG } from '@/config';
import { useEffect } from 'react';
import { toast } from 'sonner';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * @beta, not used for now
 * @constructor
 */
export const SilentSignIn = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const silentSignIn = searchParams.get('silentSignin');

  const navigate = useNavigate();
  const callbackUrl = searchParams ? searchParams.get('callbackUrl') : null;

  const onSignIn = (provider: 'cyberkoala') => {
    /// TODO: callbackUrl: DEFAULT_LOGIN_REDIRECT,
    window.location.assign(`${API_BASE}/api/auth/${provider}`);
  };

  useEffect(() => {
    if (silentSignIn === '1' || searchParams?.has('1') || silentSignIn) {
      const CasdoorSDK = new Sdk(CYBERKOALA_ID_SDK_CONFIG);
      CasdoorSDK.silentSignin(
        (message) => {
          if (typeof message === 'object') {
            const msgString = JSON.stringify(message);
            const msg = JSON.parse(msgString);
            toast(msg?.data || 'Unknown error');
          } else {
            toast(message);
          }
          return;
        },
        (message) => {
          onSignIn('cyberkoala');
          return;
        }
      );
    }
  }, [navigate, searchParams, silentSignIn]);

  return <></>;
};
